<footer>
  <nav aria-label="Navegación pie de página">
    <div class="footer-menu">
      <div class="sections-item">
        <!-- NUEVO -->
        <div class="item" [class.item-selected]="activeDropdown() === 'families-list'">
          <strong
            class="icon"
            [class.icon-plus]="activeDropdown() !== 'families-list'"
            [class.icon-minus]="activeDropdown() === 'families-list'"
            (click)="toggleDropdown('families-list')"
            >NUEVO</strong
          >
          <div
            id="families-list"
            class="item-list"
            [class.show-items]="activeDropdown() === 'families-list'"
            [class.show-all-families]="showAllFamilies()"
          >
            <div class="items-content">
              @if (newCategories().length) {
                <ul>
                  @for (category of newCategories(); track $index) {
                    <li class="familie-item">
                      <a [routerLink]="'/productos/' + category.slug">{{ category.name }}</a>
                    </li>
                  }
                </ul>
              }
              @if (!showAllFamilies()) {
                <div id="see-more">
                  <button (click)="showMore()" class="d-block">Ver más</button>
                </div>
              }
            </div>
          </div>
        </div>

        <!-- USADO -->
        <div
          class="item not-paddin-rigth-mobile"
          [class.item-selected]="activeDropdown() === 'used-list'"
        >
          <strong
            class="icon"
            [class.icon-plus]="activeDropdown() !== 'used-list'"
            [class.icon-minus]="activeDropdown() === 'used-list'"
            (click)="toggleDropdown('used-list')"
            >USADO</strong
          >
          <div
            id="used-list"
            class="item-list"
            [class.show-items]="activeDropdown() === 'used-list'"
          >
            <div class="items-content">
              @if (categoriesUsed().length) {
                <ul>
                  @for (category of categoriesUsed(); track $index) {
                    <li>
                      <a [routerLink]="'/equipo-usado/categorias/' + category.slug">{{
                        category.name
                      }}</a>
                    </li>
                  }
                </ul>
              }
              <div class="seeMore">
                <a routerLink="/equipo-usado" class="d-block">Ver más</a>
              </div>
            </div>
          </div>
        </div>

        <!-- RENTA -->
        <div class="item">
          <strong><a routerLink="/equipo-en-renta">RENTA</a></strong>
        </div>

        <!-- REFACCIONES -->
        <div
          class="item not-paddin-rigth-mobile"
          [class.item-selected]="activeDropdown() === 'families-spare-parts-list'"
        >
          <strong
            class="icon"
            [class.icon-plus]="activeDropdown() !== 'families-spare-parts-list'"
            [class.icon-minus]="activeDropdown() === 'families-spare-parts-list'"
            (click)="toggleDropdown('families-spare-parts-list')"
            >REFACCIONES</strong
          >
          <div
            id="families-spare-parts-list"
            class="item-list spare-parts-grid"
            [class.show-items]="activeDropdown() === 'families-spare-parts-list'"
          >
            <div class="items-content">
              @if (categoriesSpare().length) {
                <ul>
                  @for (spare of categoriesSpare(); track $index) {
                    <li class="spare-item">
                      <a routerLink="/refacciones/{{ spare.slug }}">{{ spare.name | titlecase }}</a>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
        </div>

        <!-- SERVICIO -->
        <div class="item">
          <strong><a routerLink="/servicio">SERVICIO</a></strong>
        </div>

        <!-- PROMOCIONES -->
        <div class="item not-paddin-rigth-mobile">
          <strong><a routerLink="/promociones">PROMOCIONES</a></strong>
        </div>

        <!-- SOLUCIONES DIGITALES -->
        <div class="item" [class.item-selected]="activeDropdown() === 'ds-list'">
          <strong
            class="icon"
            [class.icon-plus]="activeDropdown() !== 'ds-list'"
            [class.icon-minus]="activeDropdown() === 'ds-list'"
            (click)="toggleDropdown('ds-list')"
            >SOLUCIONES DIGITALES</strong
          >
          <div id="ds-list" class="item-list" [class.show-items]="activeDropdown() === 'ds-list'">
            <div class="items-content">
              @if (categoriesDS().length) {
                <ul>
                  @for (category of categoriesDS(); track $index) {
                    <li>
                      <a [routerLink]="'/soluciones-digitales/' + category.slug">{{
                        category.name
                      }}</a>
                    </li>
                  }
                </ul>
              }
            </div>
          </div>
        </div>

        <!-- SUCURSALES -->
        <div class="item not-paddin-rigth-mobile">
          <strong><a routerLink="/sucursales">SUCURSALES</a></strong>
        </div>

        <!-- BLOG -->
        <div class="item">
          <strong><a routerLink="/blog">BLOG</a></strong>
        </div>

        <!-- EMPRESA -->
        <div
          class="item not-paddin-rigth-mobile"
          [class.item-selected]="activeDropdown() === 'company-list'"
        >
          <strong
            class="icon"
            [class.icon-plus]="activeDropdown() !== 'company-list'"
            [class.icon-minus]="activeDropdown() === 'company-list'"
            (click)="toggleDropdown('company-list')"
            >EMPRESA</strong
          >
          <div
            id="company-list"
            class="item-list"
            [class.show-items]="activeDropdown() === 'company-list'"
          >
            <div class="items-content">
              <ul>
                <li><a routerLink="/empresa">Compañía</a></li>
                <li><a routerLink="/contacto">Contacto</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>

  <div class="gridLogos">
    <div class="contentImage">
      <img ngSrc="/footer/ISO.svg" alt="Certificación ISO 90001:2015" fill />
    </div>
    <div class="contentImage">
      <img ngSrc="/footer/GREAT_2026.svg" alt="Certificación Great Place To Work" fill />
    </div>
    <div class="contentImage">
      <img ngSrc="/footer/OEA.svg" alt="Acreditación de Operador Económico Autorizado" fill />
    </div>
    <div class="contentImage">
      <img ngSrc="/footer/ESR.svg" alt="Distintivo Empresa Socialmente Responsable" fill />
    </div>
  </div>

  <app-footer-legals />

  <div class="footerLinks">
    <div class="copy">
      <div class="icons">
        @if (false) {
          <div class="iconWhats">
            <a target="_blank" href="https://wa.me/523316071921">
              <i class="iconTracsa icon-whatsapp">&#xe83c;</i>
            </a>
          </div>
        }
        <div class="iconPhone">
          <a href="tel:8005614944">
            <i class="iconTracsa icon-phone">&#xe810;</i>
          </a>
        </div>
      </div>
      <p>Todos los derechos reservados Grupo TRACSA CAT {{ year }}</p>
    </div>
    <div
      id="social-media"
      class="social-media-items"
      [class.align-bottom-media]="activeDropdown() === null"
    >
      <a
        href="https://www.linkedin.com/company/tracsacat"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="iconTracsa icon-linkedin-1">&#xe852;</i>
      </a>
      <a href="https://www.instagram.com/tracsacat/" target="_blank" rel="noopener noreferrer">
        <i class="iconTracsa icon-instagram-1">&#xe851;</i>
      </a>
      <a
        href="https://www.youtube.com/user/TracsaOficial"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="iconTracsa icon-youtube-1">&#xe854;</i>
      </a>
      <a
        href="https://www.facebook.com/TracsaCaterpillar"
        target="_blank"
        rel="noopener noreferrer"
      >
        <i class="iconTracsa icon-facebook-1">&#xe850;</i>
      </a>
      <a href="https://twitter.com/TracsaCat" target="_blank" rel="noopener noreferrer">
        <div class="iconTwitter" aria-label="x"></div>
      </a>
    </div>
  </div>
</footer>
